'use client';

import { useRouter } from 'next/navigation';
import { GithubLogo } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import { EmptyState } from '@/components/EmptyState';

/**
 * Inline "connect your GitHub org" prompt shown in the right content area for
 * Google (identity-only) users on the git-dependent tabs (Code Review, Code
 * Reliability, Documentation). It is NOT a full-page takeover: the sidebar stays
 * visible so the user can navigate back to their Agent tabs. The CTA routes into
 * the existing git-org connect step of onboarding.
 */
export function GoogleConnectGitPrompt() {
  const router = useRouter();

  return (
    <div className="w-full overflow-hidden rounded-lg border border-ds-border-subtlest bg-ds-surface-white p-3">
      <div
        className="flex min-h-[355px] flex-col items-center justify-center overflow-hidden rounded-lg border border-ds-brand-subtlest px-6 py-11"
        style={{
          background:
            'radial-gradient(ellipse at 50% 8%, var(--primitive-white-solid) 77%, var(--primitive-brand-green-100) 100%)',
        }}
      >
        <EmptyState
          title="Connect your GitHub org to unlock this"
          description="Code Review, Code Reliability, and Documentation need a connected GitHub organization. Your Agent tabs stay available while you set this up."
          icon={
            <GithubLogo
              size={24}
              weight="fill"
              className="text-ds-brand-subtler"
              aria-hidden
            />
          }
          action={
            <Button
              size="sm"
              onClick={() =>
                router.push('/onboarding?step=team-insight-connect-github')
              }
            >
              Connect GitHub org
            </Button>
          }
        />
      </div>
    </div>
  );
}
